import React, { useEffect } from "react";
import { Reveal } from "../../Components/Reveal/Reveal";
import { Helmet } from "react-helmet-async";

export const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Privacy Policy - DataDept </title>
        <meta
          name="description"
          content="Reach out to DataDept for custom software development and IT consulting. Contact us today to discuss your project needs and discover how we can drive your business forward."
        />
        <link rel="canonical" href="/privacy-policy" />
      </Helmet>
      <section className="about-page-section-1 container-style">
        <div className="content-sizing about-page-section-1-wrapper">
          <div className="header-into-about-section">
            <Reveal delay={0.1}>
              <span className="light-tag">Privacy Policy</span>
            </Reveal>
            <Reveal delay={0.2}>
              <h1 className="header-tag-about">Privacy Policy for DataDept</h1>
            </Reveal>
            <Reveal delay={0.2}>
              <h2 className="sub-header-tag-about">
                This Privacy Policy details how we handle information collected
                through our website, focusing on the safety and privacy of our
                users. By engaging with DataDept, you consent to these
                practices, effective March 25, 2024, aimed at safeguarding your
                data.
              </h2>
            </Reveal>
          </div>
        </div>
      </section>
      <section className="about-page-section-1 container-style">
        <div className="content-sizing about-page-section-1-wrapper term-rules-privacy-style">
          <h1>Privacy Policy for DataDept</h1>
          <p>
            <strong>Effective Date: March 25, 2024</strong>
          </p>
          <p>
            Welcome to DataDept! We specialize in software development and are
            committed to protecting the privacy and security of our users'
            information. This Privacy Policy outlines the types of information
            we collect through our website, how it is used, and the measures we
            take to protect it.
          </p>

          <h2>1. Information Collection</h2>
          <p>
            DataDept does not collect personal information directly from our
            users. However, we use cookies and similar tracking technologies to
            collect non-personally identifiable information, including user
            location, device type, and conversion rates, to enhance our
            website's performance and user experience.
          </p>

          <h2>2. Use of Information</h2>
          <p>The information collected is used to:</p>
          <ul>
            <li>
              Understand user behavior and preferences to improve our website
              and services.
            </li>
            <li>
              Analyze device types and conversion rates to optimize our
              website's functionality.
            </li>
            <li>Enhance website security and performance.</li>
          </ul>

          <h2>3. Cookies and Tracking Technologies</h2>
          <p>
            We use cookies and other tracking technologies to collect
            information about your browsing activities and to remember your
            preferences. You have the option to disable cookies through your
            browser settings, but please note that some features of our website
            may not function properly without them.
          </p>

          <h2>4. Data Storage and Security</h2>
          <p>
            We implement a variety of security measures to maintain the safety
            of the information collected. However, no method of transmission
            over the Internet or method of electronic storage is 100% secure.
          </p>

          <h2>5. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>
              Know about the information we collect and how it is used and
              shared.
            </li>
            <li>Opt-out of certain uses of your information.</li>
            <li>Access and update your information.</li>
          </ul>

          <h2>6. Updates to Our Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on this page.
            We encourage you to review this Privacy Policy periodically for any
            changes.
          </p>

          <h2>7. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact
            us at <a href="mailto:datadept.ca@gmail.com">datadept.ca@gmail.com</a>
          </p>
        </div>
      </section>
    </>
  );
};
